module.exports = __webpack_public_path__ + "img/SmartCarTest.217f8124.gif";